export default __webpack_public_path__ + "static-bigflip/media/nib.ed94e961.png";